import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import { queryKeys } from "../../query-keys";

export function useContentModerationQueue() {
	return useQuery({
		queryKey: queryKeys.contentModeration.all,
		queryFn: () => adminApi.contentModeration.list(),
	});
}

export function useDismissContent() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => adminApi.contentModeration.dismiss(id),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.contentModeration.all,
			}),
	});
}

export function useActionContent() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => adminApi.contentModeration.action(id),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.contentModeration.all,
			}),
	});
}
